export const extractPageX = (event: MouseEvent | TouchEvent): number => {
  if ("touches" in event) {
    if (event.touches && event.touches.length > 0) {
      return event.touches[0].pageX;
    }
    if (event.changedTouches && event.changedTouches.length > 0) {
      return event.changedTouches[0].pageX;
    }
  }
  return (event as MouseEvent).pageX;
};
